import React from 'react';
import { AutoAwesome, CheckCircle, RestaurantMenu } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import './AuthShell.css';

export default function AuthShell({ eyebrow = 'NUTRIZIA', title, subtitle, children, compact = false }) {
  return <main className="auth-shell">
    <section className="auth-shell-story">
      <Link to="/" className="auth-shell-brand"><i><RestaurantMenu /></i><span><strong>Nutrizia</strong><small>Seguimiento integral</small></span></Link>
      <div className="auth-shell-story-copy">
        <span><AutoAwesome /> TU ALIMENTACIÓN, MÁS FÁCIL</span>
        <h1>Decide mejor.<br />Cocina con calma.</h1>
        <p>Planificación, recetas y seguimiento nutricional reunidos en una experiencia sencilla.</p>
      </div>
      <div className="auth-shell-benefits"><span><CheckCircle /> Menús adaptados a ti</span><span><CheckCircle /> Compra y cocina organizadas</span><span><CheckCircle /> Progreso fácil de entender</span></div>
    </section>
    <section className="auth-shell-access">
      <div className={`auth-shell-card ${compact ? 'is-compact' : ''}`}>
        <span className="auth-shell-eyebrow">{eyebrow}</span>
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
        <div className="auth-shell-content">{children}</div>
      </div>
    </section>
  </main>;
}
